export const UPDATE_GQL_QUERY = 'UPDATE_GQL_QUERY'

export const updateGqlQuery = query => ({
  type: UPDATE_GQL_QUERY,
  query,
})
